import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Actions\Answers\ClearSkippedAnswers::__invoke
* @see app/Actions/Answers/ClearSkippedAnswers.php:17
* @route '/scoring/clear-skips'
*/
const ClearSkippedAnswers = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ClearSkippedAnswers.url(options),
    method: 'post',
})

ClearSkippedAnswers.definition = {
    methods: ["post"],
    url: '/scoring/clear-skips',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Actions\Answers\ClearSkippedAnswers::__invoke
* @see app/Actions/Answers/ClearSkippedAnswers.php:17
* @route '/scoring/clear-skips'
*/
ClearSkippedAnswers.url = (options?: RouteQueryOptions) => {
    return ClearSkippedAnswers.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Answers\ClearSkippedAnswers::__invoke
* @see app/Actions/Answers/ClearSkippedAnswers.php:17
* @route '/scoring/clear-skips'
*/
ClearSkippedAnswers.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ClearSkippedAnswers.url(options),
    method: 'post',
})

export default ClearSkippedAnswers